import apiClient from '../apiClient';
import { POST_RESET_PASSWORD_URL } from '../apiUrl';

const postResetPasswordApi = data => {
  return apiClient.post(POST_RESET_PASSWORD_URL, data);
};

export default postResetPasswordApi;
